import { GLOBAL_COLORS_HOLSTER, applyCamoMarkup } from '../config/globalSettings';

// ==========================================
// 1. LIGHT GROUPINGS 
// ==========================================
// These are helpers. The actual mapping happens inside the 'guns' array below.
export const LIGHT_GROUPS = {
    UNIVERSAL: ["x300", "tlr1", "tlr7", "tlr7_hlx", "wild1", "pl350"],
    SUB_GLOCK: ["tlr7_sub_glock"],
    SUB_SIG: ["tlr7_sub_p365"],
    SUB_1913: ["tlr7_sub_1913"]
};

export const holsterData = {
  // --- BRANDS ---
  brands: [
    { id: "archon", name: "Archon" },
    { id: "arex", name: "AREX" },
    { id: "beretta", name: "Beretta" },
    { id: "cz", name: "CZ" },
    { id: "dan_wesson", name: "Dan Wesson" },
    { id: "daniel_defense", name: "Daniel Defense" },
    { id: "fn", name: "FN" },
    { id: "glock", name: "Glock" },
    { id: "hk", name: "H&K" },
    { id: "icarus", name: "Icarus Precision" },
    { id: "iwi", name: "IWI" },
    { id: "psa", name: "Palmetto State Armory (PSA)" },
    { id: "rost_martin", name: "Rost Martin" },
    { id: "shadow_systems", name: "Shadow Systems" },
    { id: "sig", name: "Sig Sauer" },
    { id: "sw", name: "Smith & Wesson" },
    { id: "staccato", name: "Staccato" },
    { id: "steyr", name: "Steyr" },
    { id: "walther", name: "Walther" }
  ],

  // --- GUN MODELS ---
  guns: [
    // ARCHON
    { 
        id: "archon_type_b", brand_id: "archon", name: "ARCHON Type B", qs_left: true,
        supported_lights: ["x300"] 
    },
    { 
        id: "archon_type_b_comp", brand_id: "archon", name: "ARCHON Type B W/VP Armory Comp", qs_left: true,
        supported_lights: ["x300"]
    },

    // AREX
    { 
        id: "arex_delta", brand_id: "arex", name: "AREX DELTA (1.0 / 2.0 M & X)", qs_left: true, 
        supported_lights: ["tlr7"] 
    },
    { 
        id: "arex_delta_l", brand_id: "arex", name: "AREX DELTA L", qs_left: true, 
        supported_lights: ["tlr7"] 
    },

    // BERETTA
    { id: "beretta_apx_a1_compact", brand_id: "beretta", name: "Beretta APX-A1 Compact" }, 
    { id: "beretta_apx_a1_full", brand_id: "beretta", name: "Beretta APX-A1 Full Size" }, 
    { 
        id: "beretta_m9_series", brand_id: "beretta", name: "Beretta M9A1/M9A3/M9A4/92G/92X (Not Performance)", qs_left: true,
        supported_lights: ["x300"]
    },
    { id: "beretta_px4", brand_id: "beretta", name: "Beretta PX4 Storm" }, 
    { id: "beretta_px4_compact", brand_id: "beretta", name: "Beretta PX4 Storm Compact" }, 

    // CZ
    { 
        id: "cz_p01", brand_id: "cz", name: "CZ P-01", qs_left: true,
        supported_lights: ["tlr7"] 
    },
    { 
        id: "cz_p07_std", brand_id: "cz", name: "CZ P-07 (DOES NOT FIT NOCTURNE)", qs_left: true,
        supported_lights: ["tlr7"] 
    },
    { 
        id: "cz_p09_std", brand_id: "cz", name: "CZ P-09 (DOES NOT FIT NOCTURNE)", qs_left: true,
        supported_lights: ["tlr7"] 
    },
    { id: "cz_p09_c_nocturne", brand_id: "cz", name: "CZ P-09 C Nocturne", qs_left: true },
    { id: "cz_p09_f_nocturne", brand_id: "cz", name: "CZ P-09 F Nocturne", qs_left: true },
    // CZ Duty 4.0 - the C, C MS and F MS variants all take the same holster.
    { id: "cz_duty_40", brand_id: "cz", name: "CZ Duty 4.0 (FITS: C, C MS, F MS)", qs_left: true },
    { 
        id: "cz_p10c", brand_id: "cz", name: "CZ P-10 C", qs_left: true,
        supported_lights: ["tlr7", "wild1", "x300"],
        supported_lights_lh: ["tlr7", "x300"]
    },
    { 
        id: "cz_p10f", brand_id: "cz", name: "CZ P-10 F", qs_left: true,
        supported_lights: ["tlr7", "wild1", "x300"],
        supported_lights_lh: ["tlr7", "x300"]
    },
    { id: "cz_p10m", brand_id: "cz", name: "CZ P-10 M", qs_left: true },
    { 
        id: "cz_p10s", brand_id: "cz", name: "CZ P-10 S", qs_left: true,
        supported_lights: ["tlr7"]
    },
    { 
        id: "cz_shadow2", brand_id: "cz", name: "CZ Shadow 2", qs_left: true,
        supported_lights: ["tlr7", "tlr7_hlx", "x300"]
    },
    { 
        id: "cz_shadow2_carry", brand_id: "cz", name: "CZ Shadow 2 Carry", qs_left: true,
        supported_lights: ["tlr7", "tlr7_hlx", "x300"]
    },
    { 
        id: "cz_shadow2_compact", brand_id: "cz", name: "CZ Shadow 2 Compact", qs_left: true,
        supported_lights: ["tlr7", "tlr7_hlx", "x300"]
    },

    // DAN WESSON
    { id: "dw_dwx_full", brand_id: "dan_wesson", name: "DW DWX Full Size", qs_left: true },
    { id: "dw_dwx_compact", brand_id: "dan_wesson", name: "DW DWX Compact (Non-railed ONLY)", qs_left: true },

    // DANIEL DEFENSE
    { id: "daniel_h9", brand_id: "daniel_defense", name: "Daniel H9", qs_left: true },

    // FN
    { id: "fn_309", brand_id: "fn", name: "FN 309", qs_left: true },
    { 
        id: "fn_509_cc_edge", brand_id: "fn", name: "FN 509 CC EDGE", qs_left: true,
        supported_lights: ["tlr1", "tlr7", "x300"],
        supported_lights_lh: ["tlr1", "x300"]
    },
    { 
        id: "fn_509_ls_edge", brand_id: "fn", name: "FN 509 LS EDGE", qs_left: true,
        supported_lights: ["tlr1", "tlr7", "x300"],
        supported_lights_lh: ["tlr1", "x300"]
    },
    { 
        id: "fn_509_series", brand_id: "fn", name: "FN 509 / M / TAC", qs_left: true,
        supported_lights: ["tlr1", "tlr7", "x300"],
        supported_lights_lh: ["tlr1", "x300"]
    },
    { 
        id: "fn_509c_series", brand_id: "fn", name: "FN 509C / 509C Tactical", qs_left: true,
        supported_lights: ["tlr1", "tlr7", "x300"],
        supported_lights_lh: ["tlr1", "x300"]
    },
    { id: "fn_reflex_series", brand_id: "fn", name: "FN REFLEX / XL MRD", qs_left: true },

    // GLOCK
    { 
        id: "glock_17_22_31", brand_id: "glock", name: "GLOCK 17/22/31 (GEN 3-6, 17M, 17 MOS)", qs_left: true,
        supported_lights: ["tlr1", "tlr2", "tlr7", "tlr7_hlx", "x300", "x400", "xvl2"],
        supported_lights_lh: ["tlr1", "tlr7", "tlr7_hlx", "x300"]
    },
    { 
        id: "glock_19_series", brand_id: "glock", name: "GLOCK 19 (GEN 3-6, 19M, 19X, G45, 19 MOS)", qs_left: true,
        supported_lights: ["tlr1", "tlr2", "tlr7", "tlr7_hlx", "x300", "x400", "xvl2"],
        supported_lights_lh: ["tlr1", "tlr7", "tlr7_hlx", "x300"]
    },
    { 
        id: "glock_34_35", brand_id: "glock", name: "GLOCK 34/35", qs_left: true,
        supported_lights: ["tlr1", "tlr2", "tlr7", "tlr7_hlx", "x300", "x400", "xvl2"],
        supported_lights_lh: ["tlr1", "tlr7", "tlr7_hlx", "x300"]
    },
    { 
        id: "glock_43_43x", brand_id: "glock", name: "GLOCK 43/43X (Includes MOS Models)", qs_left: true,
        supported_lights: ["tlr7_sub_glock", "xsc"] 
    },
    { 
        id: "glock_43_15rd", brand_id: "glock", name: "GLOCK 43/43X (Includes MOS) w/ 15 Rnd Factory Mag", qs_left: true,
        supported_lights: ["tlr7_sub_glock", "xsc"] 
    },
    { 
        id: "glock_48", brand_id: "glock", name: "GLOCK 48 (Includes MOS Models)", qs_left: true,
        supported_lights: ["tlr7_sub_glock", "xsc"] 
    },
    { 
        id: "glock_48_15rd", brand_id: "glock", name: "GLOCK 48 (Includes MOS) w/ 15 Rnd Factory Mag", qs_left: true,
        supported_lights: ["tlr7_sub_glock", "xsc"] 
    },

    // HK
    { 
        id: "hk_cc9", brand_id: "hk", name: "HK CC9", qs_left: true,
        supported_lights: ["xsc"] 
    },

    // IWI
    { id: "iwi_masada", brand_id: "iwi", name: "IWI Masada", qs_left: true },
    { id: "iwi_masada_slim_elite", brand_id: "iwi", name: "Masada Slim Elite", qs_left: true },

    // PSA
    { id: "psa_dagger_full_s", brand_id: "psa", name: "PSA Dagger Full Size-S", qs_left: true },
    { id: "psa_dagger_full_sx", brand_id: "psa", name: "PSA Dagger Full Size-SX", qs_left: true },
    { id: "psa_micro_dagger", brand_id: "psa", name: "PSA Micro Dagger", qs_left: true },

    // ROST MARTIN
    { id: "rost_martin_rm1c", brand_id: "rost_martin", name: "Rost Martin RM1C" },

    // SHADOW SYSTEMS
    { 
        id: "ss_cr920", brand_id: "shadow_systems", name: "Shadow Systems CR920", qs_left: true,
        supported_lights: ["tlr7_sub_glock"]
    },
    { 
        id: "ss_mr920", brand_id: "shadow_systems", name: "Shadow Systems MR920", qs_left: true,
        supported_lights: ["tlr1", "tlr7", "tlr7_hlx", "x300"]
    },
    { 
        id: "ss_mr920l", brand_id: "shadow_systems", name: "Shadow Systems MR920L", qs_left: true,
        supported_lights: ["tlr1", "tlr7", "tlr7_hlx", "x300"]
    },
    { 
        id: "ss_xr920", brand_id: "shadow_systems", name: "Shadow Systems XR920", qs_left: true,
        supported_lights: ["tlr1", "tlr7", "tlr7_hlx", "x300"]
    },
    { 
        id: "ss_dr920", brand_id: "shadow_systems", name: "Shadow Systems DR920", qs_left: true,
        supported_lights: ["tlr1", "tlr7", "tlr7_hlx", "x300"]
    },
    { 
        id: "ss_dr920l", brand_id: "shadow_systems", name: "Shadow Systems DR920L", qs_left: true,
        supported_lights: ["tlr1", "tlr7", "tlr7_hlx", "x300"]
    },
    { 
        id: "ss_dr920p", brand_id: "shadow_systems", name: "Shadow Systems DR920P", qs_left: true,
        supported_lights: ["tlr1", "tlr7", "tlr7_hlx", "x300"]
    },

    // ICARUS PRECISION
    { 
        id: "icarus_365xl_pmm", brand_id: "icarus", name: "Icarus 365XL PMM Comp (FITS: EVO & Icarus XMacro)", qs_left: true,
        supported_lights: ["tlr7", "tlr7_hlx", "tlr7_sub_1913"]
    },
    { 
        id: "icarus_365x_xl", brand_id: "icarus", name: "Icarus 365X/365XL (FITS: Pro Elite, EVO & Icarus XMacro)", qs_left: true,
        supported_lights: ["tlr7", "tlr7_hlx", "tlr7_sub_1913"]
    },
    { id: "icarus_ace_365_311", brand_id: "icarus", name: "Icarus ACE 365-311", qs_left: true },
    { id: "icarus_ace_365_311_fuse", brand_id: "icarus", name: "Icarus ACE 365-311 FUSE", qs_left: true },
    { id: "icarus_air", brand_id: "icarus", name: "Icarus AIR", qs_left: true },

    // SIG SAUER
    { id: "sig_1911_x_full", brand_id: "sig", name: "SIG 1911 X-FULL", qs_left: true },
    { id: "sig_p211_gto", brand_id: "sig", name: "SIG P211-GTO/GT5", qs_left: true, supported_lights: ["x300"] },
    { id: "sig_p211_gt4", brand_id: "sig", name: "SIG P211-GT4", qs_left: true },
    { id: "sig_p226_legion", brand_id: "sig", name: "SIG P226 (SAO Legion, P226 SIG Rail) DOES NOT FIT XFIVE LEGION", qs_left: true, supported_lights: ["tlr7", "x300"] },
    { id: "sig_p226_mk25", brand_id: "sig", name: "SIG P226 Mk25", qs_left: true, supported_lights: [] /* lightbearing removed - non-lightbearing only */ },
    { id: "sig_p226_x_legion_44", brand_id: "sig", name: "SIG P226-X Legion (4.4)", qs_left: true },
    { id: "sig_p226_xcarry_legion_38", brand_id: "sig", name: "SIG P226 XCarry Legion (3.8)", qs_left: true },
    { id: "sig_p226_xfive", brand_id: "sig", name: "SIG P226-XFIVE/LEGION (2022 US VERSION)", qs_left: true },
    { id: "sig_p229_9mm", brand_id: "sig", name: "SIG P229 (9mm ONLY)", qs_left: true, supported_lights: ["tlr7", "x300"]},
    { id: "sig_p320_x5_legion", brand_id: "sig", name: "SIG P320 X5/Legion", qs_left: true, supported_lights: ["tlr1", "tlr7", "wild1", "x300"],supported_lights_lh: ["tlr1", "tlr7", "x300"]},
    { id: "sig_p320c", brand_id: "sig", name: "SIG P320C (XCARRY, XCOMPACT, M18, TAC OPS)", qs_left: true, supported_lights: ["tlr1", "tlr7", "wild1", "x300"],supported_lights_lh: ["tlr1", "tlr7", "x300"]},
    { id: "sig_p320fs", brand_id: "sig", name: "SIG P320FS (Full Size, M17, XCarry Series Grip Modules)", qs_left: true, supported_lights: ["tlr1", "tlr7", "wild1", "x300"], supported_lights_lh: ["tlr1", "tlr7", "x300"]},
    { id: "sig_p365_axg_legion_gen1", brand_id: "sig", name: "SIG P365-AXG Legion (GEN 1 ONLY)", qs_left: true, supported_lights: ["tlr7_sub_1913"]},
    { id: "sig_p365_axg_legion_gen2", brand_id: "sig", name: "SIG P365-AXG Black/Legion (GEN 2 ONLY)", qs_left: true, supported_lights: ["tlr7", "tlr7_hlx", "tlr7_sub_1913"]},
    { id: "sig_p365_fuse", brand_id: "sig", name: "SIG P365 FUSE", qs_left: true, supported_lights: ["tlr7", "tlr7_hlx", "tlr7_sub_1913"]},
    { id: "sig_p365xl", brand_id: "sig", name: "SIG P365XL", qs_left: true, supported_lights: ["tlr7_sub_p365"]},
    { id: "sig_p365_xmacro", brand_id: "sig", name: "SIG P365 X-Macro (Fits Tacops Models)", qs_left: true, supported_lights: ["tlr7", "tlr7_hlx", "tlr7_sub_1913"]},
    // --- SIG P385 (new duty pistol) ---
    // Both hands; non-lightbearing and TLR-7 HL-X. Daisho is quick ship by default.
    // TLR-7/A/X ("tlr7") is NOT offered yet - planned for the following week.
    { id: "sig_p385_full", brand_id: "sig", name: "SIG P385-FULL", qs_left: true, supported_lights: ["tlr7_hlx"]},
    { id: "sig_p385_carry", brand_id: "sig", name: "SIG P385-CARRY", qs_left: true, supported_lights: ["tlr7_hlx"]},

    // SMITH & WESSON
    { id: "sw_mp2_36", brand_id: "sw", name: "S&W M&P 2.0 9/40 3.6\"", qs_left: true },
    { 
        id: "sw_mp2_40", brand_id: "sw", name: "S&W M&P 2.0 9/40 4.0\"", qs_left: true,
        supported_lights: ["x300"]
    },
    { 
        id: "sw_mp2_425", brand_id: "sw", name: "S&W M&P 2.0 9/40 4.25\"", qs_left: true,
        supported_lights: ["x300"]
    },
    { 
        id: "sw_mp2_50", brand_id: "sw", name: "S&W M&P 2.0 9/40 5.0\"", qs_left: true,
        supported_lights: ["x300"]
    },
    // M&P 2.0 METAL / STEEL FRAME - flags mirror the polymer 2.0 entries above
    { id: "sw_mp2_metal_36", brand_id: "sw", name: "S&W M&P 2.0 Metal (Steel Frame) 9/40 3.6\"", qs_left: true },
    { 
        id: "sw_mp2_metal_40", brand_id: "sw", name: "S&W M&P 2.0 Metal (Steel Frame) 9/40 4.0\"", qs_left: true,
        supported_lights: ["x300"]
    },
    { 
        id: "sw_mp2_metal_425", brand_id: "sw", name: "S&W M&P 2.0 Metal (Steel Frame) 9/40 4.25\"", qs_left: true,
        supported_lights: ["x300"]
    },
    { 
        id: "sw_mp2_metal_50", brand_id: "sw", name: "S&W M&P 2.0 Metal (Steel Frame) 9/40 5.0\"", qs_left: true,
        supported_lights: ["x300"]
    },
    { id: "sw_shield_plus_carry_comp", brand_id: "sw", name: "S&W Shield Plus Carry Comp", qs_left: true },
    { 
        id: "sw_shield_x", brand_id: "sw", name: "S&W M&P Shield X", qs_left: true,
        supported_lights: ["tlr7_sub_1913"] 
    },

    // STACCATO
    { 
        id: "staccato_c2", brand_id: "staccato", name: "Staccato C2", qs_left: true,
        supported_lights: ["tlr1", "tlr7", "x300"] 
    },
    { 
        id: "staccato_p", brand_id: "staccato", name: "Staccato P", qs_left: true,
        supported_lights: ["tlr1", "tlr7", "x300"] 
    },
    { 
        id: "staccato_xc", brand_id: "staccato", name: "Staccato XC", qs_left: true,
        supported_lights: ["tlr1", "tlr7", "x300"] 
    },
    { 
        id: "staccato_xl", brand_id: "staccato", name: "Staccato XL", qs_left: true,
        supported_lights: ["tlr1", "tlr7", "x300"] 
    },

    // STEYR
    { id: "steyr_atd_4", brand_id: "steyr", name: "Steyr ATD 4\"", qs_left: true },
    { id: "steyr_c9_a2", brand_id: "steyr", name: "Steyr C9-A2" },
    { id: "steyr_l9_a2", brand_id: "steyr", name: "Steyr L9-A2" },
    { id: "steyr_m9_a2", brand_id: "steyr", name: "Steyr M9-A2" },

    // WALTHER
    { 
        id: "walther_pdp_4", brand_id: "walther", name: "Walther PDP Compact / Full Size 4\"", qs_left: true,
        supported_lights: ["tlr1", "tlr7", "x300"] 
    },
    { 
        id: "walther_pdp_45", brand_id: "walther", name: "Walther PDP Full Size 4.5\"", qs_left: true,
        supported_lights: ["tlr1", "tlr7", "x300"] 
    },
    { 
        id: "walther_pdp_5", brand_id: "walther", name: "Walther PDP Full Size 5\"", qs_left: true,
        supported_lights: ["tlr1", "tlr7", "x300"] 
    },

    { id: "walther_q4", brand_id: "walther", name: "Walther Q4" },
    { id: "walther_q5", brand_id: "walther", name: "Walther Q5" }
  ],

  // --- LIGHTS ---
  lights: [
    { id: "tlr1", name: "Streamlight TLR-1 / HL" },
    { id: "tlr2", name: "Streamlight TLR-2 / HL" },
    { id: "tlr7", name: "Streamlight TLR-7 / 7A / 7X" },
    { id: "tlr7_hlx", name: "Streamlight TLR-7 HL-X" },
    { id: "tlr7_sub_1913", name: "Streamlight TLR-7 SUB (1913)" },
    { id: "tlr7_sub_glock", name: "Streamlight TLR-7 SUB (Glock)" },
    { id: "tlr7_sub_p365", name: "Streamlight TLR-7 SUB (Sig)" },
    { id: "x300", name: "Surefire X300 U / T (A & B)" },
    { id: "x400", name: "Surefire X400 Ultra" },
    { id: "xvl2", name: "Surefire XVL2" },
    { id: "wild1", name: "Inforce WILD 1" },
    { id: "xsc", name: "Surefire XSC" }
  ],

  // --- OPTIONS ---
  hands: [ { id: "right", name: "Right Handed" }, { id: "left", name: "Left Handed" } ],
  
  lightbearing_options: [ 
      { id: "no", name: "Non-Lightbearing" }, 
      { id: "yes", name: "Lightbearing" } 
  ],

  // --- WING COLORS ---
  // Production wings are Curv composite.
  wing_colors: [
    { id: "odg", name: "OD Green Curv Wing", price: 0 },
    { id: "coyote_carbon", name: "Coyote Curv Wing", price: 0 },
    { id: "black", name: "Black Curv Wing", price: 0 }
  ],

  // --- CLAW COLORS ---
  claws: [
    { id: "black", name: "Black Concealment Claw", price: 0 },
    { id: "odg", name: "OD Green Concealment Claw", price: 0 },
    { id: "coyote", name: "Coyote Concealment Claw", price: 0 }
  ],

  // --- COLORS (Global - Mapped to $30 markup) ---
  colors: applyCamoMarkup(GLOBAL_COLORS_HOLSTER, 30),

  // --- MOUNTS ---
  mounts: [
     { 
      id: "dcc_ANRlogo", 
      name: "1.5\" DCC ANR Logo", 
      price: 7.25, 
      img_layer_mount: "/images/mounts/daisho/dccanrlogo_front.png", 
      img_layer_mount_back: "/images/mounts/daisho/dccanrlogo_back.png",
      description: "Heat treated steel alloy. High clamping force."
    },
    { 
      id: "dcc_nologo", 
      name: "1.5\" DCC No Logo", 
      price: 6.25, 
      img_layer_mount: "/images/mounts/daisho/dcc_nologo_front.png", 
      img_layer_mount_back: "/images/mounts/daisho/dcc_nologo_back.png",
      description: "Heat treated steel alloy. Clean, no logo finish."
    },
    { 
      id: "dcc_TOPOlogo", 
      name: "1.5\" DCC TOPO", 
      price: 8.25, 
      img_layer_mount: "/images/mounts/daisho/dcctopo_front.png", 
      img_layer_mount_back: "/images/mounts/daisho/dcctopo_back.png",
      description: "Heat treated steel alloy with TOPO design."
    },
    { 
      id: "dcc_tigerstripe", 
      name: "1.5\" DCC Tiger Stripe", 
      price: 8.25, 
      img_layer_mount: "/anr-builder/images/mounts/daisho/dcctigerstripe_front.png", 
      img_layer_mount_back: "/anr-builder/images/mounts/daisho/dcctigerstripe_back.png",
      description: "Heat treated steel alloy with Tiger Stripe design."
    },
    { 
      id: "dcc_FDElogo", 
      name: "1.5\" DCC FDE", 
      price: 7.25, 
      img_layer_mount: "/images/mounts/daisho/dccfde_front.png", 
      img_layer_mount_back: "/images/mounts/daisho/dccfde_back.png",
      description: "Heat treated steel alloy in FDE."
    },
    { 
      id: "neomag", 
      name: "NeoMag Alias T Post", 
      price: 15.99, 
      img_layer_mount: "/images/mounts/daisho/neomag_front.png",
      img_layer_mount_back: "/images/mounts/daisho/neomag_back.png",
      description: "Premium clip-less system. Requires NeoMag Alias belt receiver."
    },
    {
      id: "neomag_receiver", 
      name: "Neomag Alias TPost and Neomag Alias Belt Receiver",
      price: 49.99, 
      img_layer_mount: "/images/mounts/daisho/neomagreciever_front.png",
      img_layer_mount_back: "/images/mounts/daisho/neomagreciever_back.png",
      description: "Neomag T Post attached to the holster with the Receiver Addon."
    },
  ],

  // --- BREAKTHROUGH ---
  breakthrough: [ 
    { id: "no", name: "No Thanks", price: 0 }, 
    { id: "solvent", name: "Breakthrough Military Grade Solvent", price: 8.95 },
    { id: "oil", name: "Breakthrough Battle Born High Purity Oil", price: 8.95 },
    { id: "lubricant", name: "Breakthrough Battle Born Pro Lubricant", price: 12.95 },
    { id: "bundle", name: "Breakthrough Clean Bundle", price: 16.00 }
  ],

  // --- WARRANTY ---
  warranties: [ 
    { id: "30_day", name: "30 Day Mfg Warranty", price: 0 }, 
    { id: "lifetime", name: "Lifetime Warranty", price: 12.99 } 
  ]
};